import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// per non avere errori di compilazione quando uso window.dataLayer
declare global {
  interface Window {
    dataLayer: any[]
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  constructor(private router: Router) { }

  /**
   * Registra l'evento sul google tag manager
   * @param eventName Il nome dell'evento, es. 'login'
   * @param extraParams Eventuali altre informazioni che voglio passare, es. { element: 'button', page: 'home' }
   */
  newEvent(nameEvent: string, eventParams?: any) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: nameEvent,
      page: this.router.url,
      ...eventParams
    })
  }
}